import { createTheme } from "@mui/material";
import Montserrat from "../assets/fonts/Montserrat-Regular.ttf";
import MontserratBold from "../assets/fonts/Montserrat-SemiBold.ttf";

const montserrat = {
  fontFamily: "Montserrat",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 500,
  src: `
    local('Montserrat'),
    local('Montserrat-Regular'),
    url(${Montserrat}) format('truetype')
  `
};

const montserratBold = {
  fontFamily: "Montserrat",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 600,
  src: `
    local('Montserrat'),
    local('Montserrat-Bold'),
    url(${MontserratBold}) format('truetype')
  `
};

const theme = createTheme({
  typography: {
    fontFamily: ['Noto Sans TC', 'Montserrat'].join(",")
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": ['Noto Sans TC', montserrat, montserratBold]
      }
    }
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          ':hover:not(.Mui-disabled, .Mui-error):before': {
            borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important'
          }
        }
      }
    }
  }
});

export default theme;